require('./navigation-np.js');

var App = App || {};
var $nav = $('#z-nav'),
    $header = $('.header-main'),
	$hamburger = $('.js-toggle-nav');

var disableBodyScroll = function () {
    var _selector = false;
    var _element = false;
    var _clientY;

    var preventBodyScroll = function (event) {
        event.preventDefault();
    };

    var captureClientY = function (event) {
        if (event.targetTouches.length === 1) {
            _clientY = event.targetTouches[0].clientY;
        }
    };

    var preventOverscroll = function (event) {
        if (event.targetTouches.length !== 1) {
            return;
        }

        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_element.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }

        if ((_element.scrollHeight - _element.scrollTop <= _element.clientHeight) && clientY < 0) {
            event.preventDefault();
        }

    };

    return function (allow, selector) {
        if (typeof selector !== "undefined") {
            _selector = selector;
            _element = document.querySelector(selector);
        }

        if (true === allow) {
            if (false !== _element) {
                _element.addEventListener('touchstart', captureClientY, false);
                _element.addEventListener('touchmove', preventOverscroll, false);
            }
            document.body.addEventListener("touchmove", preventBodyScroll, false);
        } else {
            if (false !== _element) {
                _element.removeEventListener('touchstart', captureClientY, false);
                _element.removeEventListener('touchmove', preventOverscroll, false);
            }
            document.body.removeEventListener("touchmove", preventBodyScroll, false);
        }
    };
};

var disableCurrentLink = function () {
    var $links = $nav.find('.z-nav__link');
    var currentPath = location.pathname;
    var currentHref = location.href;

    $links.each(function(index, item) {
        var href = $(item).prop('href');
        if (href === currentPath || href === currentHref) {
            $(item).addClass('z-nav__link--disable')
        }
    })
}


App.initNavDesktop = function () {
	$nav
		.on('click', '.z-nav__link--1:not(.is-hovered)', function (e) {
			if ($(window).outerWidth() > 1024) {
				e.preventDefault();
				App.showChildsDesktop($(this));
			}
		})
		.on('click', '.popup__close', function (e) {
			e.preventDefault();
			if ($(window).outerWidth() > 1024) App.hideChildsDesktop();
		});

    $(document)
        .on('click', function (e) {
            if (!$header.is(e.target) && $header.has(e.target).length === 0) {
                if ($(window).outerWidth() > 1024) App.hideChildsDesktop();
            }
        })
		.on('scroll', function () {
            var availableHeight = $(window).height() - $('.header').outerHeight();
            if ($(window).outerWidth() > 1024 && App.menuHeight < availableHeight) {
                App.hideChildsDesktop();
            } else {
                App.setPosition();
            }
		});

    disableCurrentLink();
};

App.showChildsDesktop = function ($link) {
	var $childs = $nav.find('.z-nav__link--1 + .z-nav__childs');
	var $links = $nav.find('.z-nav__link--1');
	var $linkChild = $link.siblings('.z-nav__childs');

	$childs.velocity('stop').css({
		display: 'none',
		opacity: '0',
		top: $('.header').outerHeight() - $(document).scrollTop() + 'px'
	});
	$links.removeClass('is-hovered');
	$links.attr('aria-expanded', false);
	$links.parent().removeAttr('aria-current');

	if ($header.hasClass('nav--opened')) {
		$linkChild.css({
			display: 'block',
			opacity: '1'
		});
		$header.addClass('nav--opened');
		$link.addClass('is-hovered');
		$link.attr('aria-expanded', true);
		$link.parent().attr('aria-current', 'page');
	} else {
		$linkChild.velocity('stop').velocity('transition.fadeIn', {
			begin: function begin() {
				$link.addClass('is-hovered');
				$link.attr('aria-expanded', true);
				$link.parent().attr('aria-current', 'page');
			}
		});
	}

    App.menuHeight = App.getMenuHeight();
};

App.setPosition = function () {
    var $childs = $nav.find('.z-nav__link--1 + .z-nav__childs');

    $childs.velocity('stop').css({
		top: $('.header').outerHeight() - $(document).scrollTop() + 'px'
	});
}

App.getMenuHeight = function () {
    var $childs = $nav.find('.z-nav__link--1 + .z-nav__childs');
    var maxHeight = 0;

    $childs.each((index, item) => {
        if ($(item).outerHeight() > maxHeight){
            maxHeight = $(item).outerHeight()
        }
    })
    return maxHeight
}

App.hideChildsDesktop = function () {
	var $links = $nav.find('.z-nav__link--1');
	var $childs = $nav.find('.z-nav__link--1 + .z-nav__childs');
	var $currentLink = $nav.find('.z-nav__link--1 .is-current')

	$childs.velocity('stop').css({
		display: 'none',
		opacity: '0'
	});
	$links.removeClass('is-hovered');
	$header.removeClass('nav--opened');
	$currentLink.attr('aria-expanded', false);
	$currentLink.parent().removeAttr('aria-current');
};

/* MOBILE */

App.initNavMobile = function () {
	App.setActiveLinks();

	$hamburger.on('click', function () {
		if ($(window).outerWidth() <= 1024) {
			App.toggleNavMobile();
			window.scrollTo(0,0);
		}

        if ($nav.hasClass('is-open')) {
            disableBodyScroll(true, '.z-nav');
        } else {
            disableBodyScroll(false, '.z-nav');
        }
	});

	$(document).on('click', function (e) {
		if ($nav.hasClass('is-open')) {
			if ($(window).outerWidth() <= 1024) {
				if (!$nav.is(e.target) && $nav.has(e.target).length === 0 && !$hamburger.is(e.target) && $hamburger.has(e.target).length === 0) {
					App.toggleNavMobile();
				}
			}
		}
	});

	$nav.on('click', '.z-nav__link--1, .z-nav__childs-item--parent > .z-nav__link--2', function (e) {
		if ($(window).outerWidth() <= 1024) {
			if (!$(this).hasClass('z-nav__link--home') && !$(this).hasClass('z-nav__link--sub')) {
				e.preventDefault();
				App.showChildsMobile($(this));
			}
		}
	}).on('click', '.z-nav__link--back', function (e) {
		if ($(window).outerWidth() <= 1024) {
			e.preventDefault();
			App.hideChildsMobile($(this));
		}
	});

    disableCurrentLink();
};

App.setActiveLinks = function () {
	var arPathName = location.pathname.split('/');
	var realArPathName = arPathName.filter(function (el) {
		return el.length;
	});

	var path = '';
	for (var i = 0; i < realArPathName.length; i++) {
		path += '/' + realArPathName[i];
		$nav.find('.z-nav__link--' + (i + 1) + ':not(.z-nav__link--sub)[href="' + path + '/"]').addClass('is-current');
	}
};

App.toggleNavMobile = function () {
	$('body').toggleClass('nav--opened');
	$header.toggleClass('nav--opened');
	$hamburger.toggleClass('is-active');
	$nav.toggleClass('is-open');
};

App.showChildsMobile = function ($link) {
	var $childs = $nav.find('.z-nav__link--1 + .z-nav__childs');
	var $links = $nav.find('.z-nav__link--1');
	var $linkChild = $link.siblings('.z-nav__childs');

	$linkChild.velocity('stop').velocity({
		translateX: ['0%', '100%']
	}, {
		begin: function begin() {
			$link.addClass('is-hovered');
			$linkChild.css({
				display: 'block',
				opacity: '1'
			});
		}
	});
};

App.hideChildsMobile = function ($linkBack) {
	var $childsOpened = $linkBack.closest('.z-nav__childs');
	var $linkHovered = $childsOpened.siblings('.z-nav__link.is-hovered');

	$childsOpened.velocity('stop').velocity({
		translateX: ['100%', '0%']
	}, {
		complete: function complete() {
			$linkHovered.removeClass('is-hovered');
			$childsOpened.css({
				display: 'none',
				opacity: '0'
			});
		}
	});
};

App.initNavDesktop();
App.initNavMobile();



// WEBPACK FOOTER //
// ./frontend/components/navigation/navigation.js